<template>
  <v-container>
    <h2>
      マイ機器の登録/変更/削除
    </h2>
    <br>
    <div class="mb-3 body-2">
      分析対象オイルに紐づく機器を、マイ機器として登録しましょう。<br>
      マイ機器では機器に関する３つの情報を管理することができます。
    </div>
    <div class="my-4">
      <h3>マイ機器で管理できる情報</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4">
      <v-row>
        <v-col cols="12" dense class="pa-0">
          <v-icon color=primary>mdi-flag</v-icon><span class="ml-2 primary--text title font-weight-bold">機器情報</span>
        </v-col>
        <v-col cols="12" dense class="pa-2 pl-6 body-2">
            機器名や機器の製造メーカー、型式、搭載油量等を管理することができます
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" dense class="pa-0">
          <v-icon color=primary>mdi-flag</v-icon><span class="ml-2 primary--text title font-weight-bold">オイル情報</span>
        </v-col>
        <v-col cols="12" dense class="pa-2 pl-6 body-2">
            オイルメーカー、オイル銘柄、オイル交換日・交換量、前回ご依頼日時などの項目があります
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" dense class="pa-0">
          <v-icon color=primary>mdi-flag</v-icon><span class="ml-2 primary--text title font-weight-bold">分析診断情報</span>
        </v-col>
        <v-col cols="12" dense class="pa-2 pl-6 body-2">
            分析方法や分析項目、フィルターやサンプルの返却要否のオプションなどの項目があります
        </v-col>
      </v-row>
    </div>
    <div class="my-4">
      <h3>機器情報</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      機器情報として管理可能な項目は次の通りです。「必須」とある項目に<v-icon color=success>mdi-check</v-icon>チェックが入っている項目は入力必須です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="machineData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">必須</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in machineData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td v-if="item.isRequire==true"><v-icon small color=success>mdi-check</v-icon></td>
              <td v-else></td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="mb-4 mt-8">
      <h3>オイル情報</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      オイル情報として管理可能な項目は次の通りです。「必須」とある項目に<v-icon color=success>mdi-check</v-icon>チェックが入っている項目は入力必須です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="oilData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">必須</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in oilData" :key="item.name">
              <td class="caption" width="165px">{{ item.name }}</td>
              <td v-if="item.isRequire==true"><v-icon small color=success>mdi-check</v-icon></td>
              <td v-else></td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="mt-8 mb-4">
      <h3>分析診断情報</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      分析情報として管理可能な項目は次の通りです。「必須」とある項目に<v-icon color=success>mdi-check</v-icon>チェックが入っている項目は入力必須です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="analizeData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">必須</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in analizeData" :key="item.name">
              <td class="caption" width="165px">{{ item.name }}</td>
              <td v-if="item.isRequire==true"><v-icon small color=success>mdi-check</v-icon></td>
              <td v-else></td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>


    <div class="mt-8 mb-4">
      <v-card  outlined color="teal" class="mx-auto" max-width="90%">
        <v-card-title>
          <v-icon color="white">mdi-note-outline</v-icon>
          <span class="white--text body-1 font-weight-light">マイ機器と搭載オイルの紐づきについて</span>          
        </v-card-title>
        <v-card-text class="body-2 white--text">
        １つの機器に登録できるオイルは１種類のみとなっています。同一機器で複数のオイルを登録したい場合は、オイルごとに別の機器として登録してください。
        </v-card-text>
      </v-card>
    </div>

    <div class="my-8 mb-4">
      <h3>マイ機器メニューの表示</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      マイ機器メニューは画面上部の「メニュー」から、「マイ機器」を選択します。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-machine-edit-01.png" width="70%" class="my-2">
    </div>

    <div class="my-8 mb-4">
      <h3>マイ機器の登録</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 my-4 body-2">
      マイ機器を登録する際は、マイ機器画面内の「マイ機器を登録」ボタンをクリックします。
    </div>
    <div class="ml-4 my-4 body-2">
      <img src="/img/man-machine-edit-02.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      マイ機器情報登録画面が開きますので、各項目に入力してください。「必須」マークがあるものは必須項目ですので必ず登録してください。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-03.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      項目への入力が完了したら「マイ機器を登録する」ボタンをクリックしてください。<br>
      登録内容の確認画面が開きます。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-04.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      登録内容の確認画面にて入力内容の最終確認をしてください。
      内容に問題が無ければ画面下部の「マイ機器を登録する」ボタンをクリックしてください。
    </div>
    <div class="ml-4 my-4 body-2">
      <img src="/img/man-machine-edit-05.png" width="90%" class="my-2">
    </div>
    <div class="ml-4 mb-10 body-2">
      <img src="/img/man-machine-edit-06.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      入力内容に誤りがある場合はエラー画面が開きますので、エラー箇所を修正して再度登録してください。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-07.png" width="30%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>マイ機器の変更</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-10 body-2">
      登録済みのマイ機器を変更する場合は、マイ機器画面にあるマイ機器リストの変更対象機器をクリックしてください
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-08.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      マイ機器情報更新画面が開きますので、変更する項目に入力してください。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-09.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      項目への入力が完了したら「マイ機器を更新する」ボタンをクリックしてください。<br>
      登録内容の確認画面が開きます。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-10.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      登録内容の確認画面にて入力内容の最終確認をしてください。
      内容に問題が無ければ画面下部の「マイ機器を更新する」ボタンをクリックしてください。
    </div>
    <div class="ml-4 my-4 body-2">
      <img src="/img/man-machine-edit-11.png" width="90%" class="my-2">
    </div>
    <div class="ml-4 mb-10 body-2">
      <img src="/img/man-machine-edit-12.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      入力内容に誤りがある場合はエラー画面が開きますので、エラー箇所を修正して再度更新してください。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-07.png" width="30%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>マイ機器の削除</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-10 body-2">
      登録済みのマイ機器を削除する場合は、マイ機器画面にあるマイ機器リストの削除する機器をクリックしてください。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-08.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      マイ機器情報更新画面が開きますので、画面最下部の右にある「このマイ機器を削除」ボタンをクリックしてください。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-13.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      マイ機器削除の確認画面が開きますので、「削除する」をクリックしてください。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-14.png" width="60%" class="my-2">
    </div>




  </v-container>
</template>
<script>
export default {
    data: () => ({
        buttonName: '',
        machineData: [
          {
            name: 'マイ機器名',
            body: '機器を識別する名称です。任意の名前を付けてください',
            isRequire: true
          },
          {
            name: 'マイ機器ID',
            body: '機器を識別するIDです。車両ナンバーや製造番号など、機器を識別できる任意の内容を入力してください',
            isRequire: true
          },
          {
            name: '製造メーカー名',
            body: '機器の製造メーカー名を入力してください。',
            isRequire: false
          },
          {
            name: '型式',
            body: '機器の型式を入力してください。',
            isRequire: false
          },
          {
            name: '機器導入日',
            body: '機器の導入日を入力してください。機器の経年を管理することができます',
            isRequire: false
          },
          {
            name: 'システム油量',
            body: '機器に搭載されている油量を登録してください',
            isRequire: true
          },
          {
            name: '使用時間／距離',
            body: '機器の使用時間、または距離（走行距離など）の通算の数値を入力してください。',
            isRequire: false
          },
          {
            name: 'メモ',
            body: '機器に紐づくメモがあれば入力してください。',
            isRequire: false
          },
        ],
        oilData: [
          {
            name: '使用オイルメーカー',
            body: '機器に搭載しているオイルのメーカーを入力してください。',
            isRequire: true
          },
          {
            name: '使用オイル銘柄／番手',
            body: '機器に搭載しているオイルの銘柄、または番手を入力してください。',
            isRequire: true
          },
          {
            name: '前回分析後のオイル交換日',
            body: '前回分析依頼をした後に、当該オイルの交換を行った場合はオイル交換日を入力してください',
            isRequire: false
          },
          {
            name: 'オイル交換量',
            body: 'オイル交換を行う際の交換量を入力してください',
            isRequire: true
          },
          {
            name: '前回分析依頼日時',
            body: '入力は不要です。前回ご依頼いただいた場合はご依頼日が自動的に入力されます。',
            isRequire: false
          },
          {
            name: '前回分析依頼番号',
            body: '入力は不要です。前回ご依頼いただいた場合は依頼番号が自動的に入力されます。',
            isRequire: false
          },
          {
            name: '使用オイルに危険物が',
            body: 'オイルに危険物がある場合は「あります」を選択してください。「あります」を選択すると内容記載欄が開きますので、危険物内容を入力してください。',
            isRequire: false
          },
        ],
        analizeData: [
          {
            name: '分析方法',
            body: '社定法か、公定法のいずれかを選択してください。',
            isRequire: true
          },
          {
            name: '分析区分',
            body: '選択メニューからいずれかを選択してください。',
            isRequire: true
          },
          {
            name: 'セット分析',
            body: '分析区分にセット分析メニューがある場合は表示されます。セット分析としてご依頼される場合はいずれかを選択してください。「セットに含まれる分析項目」に選択したセットに含まれる分析項目が表示されます。',
            isRequire: false
          },
          {
            name: '個別分析項目',
            body: '個々に分析項目を指定してご依頼される場合は、選択メニューからいずれかを選択してください。',
            isRequire: false
          },
          {
            name: '報告書に分析規格を記載する',
            body: '分析結果の報告書に分析規格を記載する場合は選択してください。有効にすると分析規格の選択が開きます',
            isRequire: false
          },
          {
            name: '分析規格',
            body: '報告書に分析規格を記載する場合は選択してください。',
            isRequire: false
          },
          {
            name: 'フィルター返却',
            body: '分析後にフィルター返却を望まれる場合は、必要のいずれかを選択してください。ラミネート加工の有無で費用が変動します。',
            isRequire: false
          },
          {
            name: 'サンプルの返却',
            body: '分析後にサンプルの返却を望まれる場合は、「返却を希望」を選択してください。着払いで返送いたします。',
            isRequire: false
          },


        ],
    }),
    methods: {
    }
}
</script>
<style lang="scss" scope>
</style>

